"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeFilter = void 0;
var ChargeFilter = /** @class */ (function () {
    function ChargeFilter(el) {
        this.i18n = {};
        this.isOpen = false;
        this.activeOptions = [];
        this.activeOptionsOnOpen = [];
        this.el = el;
    }
    ChargeFilter.prototype.init = function (i18nStrings) {
        this.i18n = i18nStrings;
        this.initDom();
        this.initListeners();
    };
    ChargeFilter.prototype.initDom = function () {
        this.toggle = this.el.querySelector('.js-rcg-transfer-charge-button');
        this.toggleText = this.toggle.querySelector('.js-rcg-transfer-charge-button-text');
        this.listContainer = this.el.querySelector('.js-rcg-transfer-charge-list-container');
        this.list = this.el.querySelector('.js-rcg-transfer-charge-list');
        this.checkboxes = this.list.querySelectorAll('.js-rcg-transfer-charge-checkbox');
        this.doneButton = this.el.querySelector('.js-rcg-transfer-charge-done');
        this.resetButton = this.el.querySelector('.js-rcg-transfer-charge-reset');
        this.reset();
    };
    ChargeFilter.prototype.initListeners = function () {
        var _this = this;
        window.addEventListener('click', function (e) {
            if (_this.isOpen)
                _this.closeAndCallback();
        });
        window.addEventListener('keydown', function (e) {
            if ((e.key === 'Esc' || e.key === 'Escape') && _this.isOpen) {
                _this.closeAndCallback();
            }
        });
        this.el.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        this.toggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.listContainer.classList.contains('rcg-transfer-charge-list-container--open')) {
                _this.closeAndCallback();
            }
            else {
                _this.open();
            }
        });
        var _loop_1 = function (i) {
            this_1.checkboxes[i].addEventListener('click', function (e) {
                var checkbox = _this.checkboxes[i];
                if (checkbox.checked) {
                    _this.activeOptions.push(checkbox.value);
                }
                else {
                    _this.activeOptions.splice(_this.activeOptions.indexOf(checkbox.value), 1);
                }
                if (_this.isFilteringActive()) {
                    _this.resetButton.hidden = false;
                }
                else {
                    _this.resetButton.hidden = true;
                }
                _this.updateToggle();
                // if (this.optionsChangeCallback) this.optionsChangeCallback(this.activeOptions);
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.checkboxes.length; i++) {
            _loop_1(i);
        }
        this.doneButton.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.isOpen)
                _this.closeAndCallback();
        });
        this.resetButton.addEventListener('click', function (e) {
            e.preventDefault();
            _this.reset(true);
            if (_this.isOpen)
                _this.closeAndCallback();
            // if (this.optionsChangeCallback) this.optionsChangeCallback(this.activeOptions);
        });
    };
    ChargeFilter.prototype.onOptionsChange = function (cb) {
        this.optionsChangeCallback = cb;
    };
    ChargeFilter.prototype.getFilterOptions = function () {
        return this.activeOptions;
    };
    ChargeFilter.prototype.isFilteringActive = function () {
        return !!this.activeOptions.length;
    };
    ChargeFilter.prototype.isFilteringFullyActive = function () {
        return this.activeOptions.length === this.checkboxes.length;
    };
    ChargeFilter.prototype.open = function () {
        this.listContainer.classList.add('rcg-transfer-charge-list-container--open');
        this.toggle.classList.add('rcg-transfer-charge-button--open');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
        this.activeOptionsOnOpen = __spreadArray([], this.activeOptions, true);
    };
    ChargeFilter.prototype.close = function () {
        this.listContainer.classList.remove('rcg-transfer-charge-list-container--open');
        this.toggle.classList.remove('rcg-transfer-charge-button--open');
        this.toggle.setAttribute('aria-expanded', 'false');
        this.isOpen = false;
    };
    ChargeFilter.prototype.closeAndCallback = function () {
        this.close();
        if (!this.optionsChangeCallback)
            return;
        if (JSON.stringify(this.activeOptions.sort()) !== JSON.stringify(this.activeOptionsOnOpen.sort())) {
            this.optionsChangeCallback(this.activeOptions);
        }
    };
    ChargeFilter.prototype.setEnabledOptions = function (options) {
        if (options === void 0) { options = []; }
        if (options) {
            for (var i = 0; i < this.checkboxes.length; i++) {
                if (options.indexOf(this.checkboxes[i].value) > -1) {
                    this.checkboxes[i].disabled = false;
                    continue;
                }
                this.checkboxes[i].disabled = true;
            }
            return;
        }
        for (var i = 0; i < this.checkboxes.length; i++) {
            this.checkboxes[i].disabled = false;
        }
    };
    ChargeFilter.prototype.reset = function (keepDisabled) {
        if (keepDisabled === void 0) { keepDisabled = false; }
        this.resetButton.hidden = true;
        this.activeOptions = [];
        for (var i = 0; i < this.checkboxes.length; i++) {
            var checkbox = this.checkboxes[i];
            checkbox.checked = false;
            if (!keepDisabled)
                checkbox.disabled = false;
        }
        this.updateToggle();
    };
    ChargeFilter.prototype.updateToggle = function () {
        if (!this.isFilteringActive()) {
            this.toggleText.textContent = this.i18n['railcargo.transfer.charge.label'];
            this.toggle.classList.remove('rcg-transfer-charge-button--active');
            return;
        }
        if (this.isFilteringFullyActive()) {
            this.toggleText.textContent = this.i18n['railcargo.transfer.loads.all'];
            this.toggle.classList.add('rcg-transfer-charge-button--active');
            return;
        }
        this.toggleText.textContent = this.i18n['railcargo.transfer.charge.loads.' + this.activeOptions.length];
        this.toggle.classList.add('rcg-transfer-charge-button--active');
    };
    return ChargeFilter;
}());
exports.ChargeFilter = ChargeFilter;
